import React from 'react';

const Badge = ({ type, children }) => {
  const styles = {
    confirmed: "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20",
    recommended: "bg-blue-500/10 text-blue-400 border border-blue-500/20",
    verify: "bg-amber-500/10 text-amber-400 border border-amber-500/20",
    internal: "bg-purple-500/10 text-purple-400 border border-purple-500/20",
    danger: "bg-red-500/10 text-red-400 border border-red-500/20"
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${styles[type] || styles.recommended}`}>
      {children}
    </span>
  );
};

export default Badge;